var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "m.841 0 7.424 9.928L.795 18h1.682l6.54-7.067L14.3 18h5.721l-7.84-10.486L19.135 0h-1.682L11.43 6.508 6.564 0H.842m2.472 1.239h2.628L17.548 16.76H14.92z"
  })));
};
export default SvgX;